<div class="content-header">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="callout callout-info">
					<h5>{{info.titulo}}</h5>
					<p *ngFor="let i of info.contenido" [innerHtml]="i.text"></p>
					<p>Consulta información y ayuda en los botónes <i class="fas fa-info-circle text-info"></i>, ubicados a lo largo de la sección.</p>
				</div>
			</div>
		</div>
	</div>
</div>